import { render, staticRenderFns } from "./IndividualPerformance.vue?vue&type=template&id=76496ff4&"
import script from "./IndividualPerformance.vue?vue&type=script&lang=js&"
export * from "./IndividualPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports